import * as React from "react";
import { createRoot } from "react-dom/client";

import type { CodingAdviceAPI } from "../../models";

interface TEEControlProps {
  className?: string;
  options: CodingAdviceAPI;
  children?: React.ReactNode;
}

export class TEEControl extends React.PureComponent<TEEControlProps> {
  render() {
    const className = this.props.className ? `${this.props.className} full-height` : "full-height";
    return <div className={className}>{this.props.children}</div>;
  }

  tcClose = () => {
    const el = this.props.options.el as HTMLElement;
    const specificElement = document.getElementById(el.id);

    if (specificElement) {
      const root = createRoot(specificElement);
      root.unmount();
    }
  };

  // FIXME: finish TEE control BaseView stubs as/if/when necessary
  tcOff = (event: string, callback: any) => {
    //
  };

  tcOn = (event: string, callback: any, doOnce?: boolean) => {
    //
  };

  tcTrigger = (event: string, options: any) => {
    //
  };

  tcVisible = (isVisible?: boolean) => {
    //
  };
}
